import React, { useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row, Nav, Container, Tab, Accordion, Modal, Table, Form, InputGroup } from 'react-bootstrap';
import { useSelector, useDispatch } from "react-redux";
import './PriceList.css';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { Search } from 'react-bootstrap-icons';

function PriceListKKT() {
    const [searchTerm, setSearchTerm] = useState('');
    const customBsPrefix = 'custom-accordion';
    
    const { kitchenThingsData } = useSelector(
        (state) => state.kitchenThings
    );
      
    const { bedroomThingsData } = useSelector(
        (state) => state.bedroomThings
    );
      
    const { foyerThingsData } = useSelector(
        (state) => state.foyerThings
    );
      
    const { livingThingsData } = useSelector(
        (state) => state.livingThings
    );
      
    const { otherWorkThingsData } = useSelector(
        (state) => state.OtherWorkThings
    );
      
    const { looseThingsData } = useSelector(
        (state) => state.looseThings
    );
    
    const { accessoriesThingsData } = useSelector(
        (state) => state.accessories
    );

    // Function to filter items based on search term
    const filterItemsBySearch = (items) => {
        if (!searchTerm) return items;
        
        return items.filter(item => 
            item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.material.some(mat => mat.label.toLowerCase().includes(searchTerm.toLowerCase()))
        );
    };

    // Get all categories data for global search
    const allCategories = [
        { name: 'Kitchen', data: kitchenThingsData },
        { name: 'Bedroom', data: bedroomThingsData },
        { name: 'Foyer', data: foyerThingsData },
        { name: 'Living Room', data: livingThingsData },
        { name: 'Other Works', data: otherWorkThingsData },
        { name: 'Loose Furniture', data: looseThingsData },
        { name: 'Accessories', data: accessoriesThingsData },
    ];
    
    // Filter categories with matching items
    const matchedCategories = searchTerm ? 
        allCategories.filter(category => 
            filterItemsBySearch(category.data).length > 0
        ) : 
        [];

    // Function to render an item row with price markup for woodwork
    const renderItemRow = (item) => (
        <Row key={item.name} style={{display:'flex', flexDirection:'row', marginBottom:'2%', borderBottomWidth:2, borderBottomColor:'whitesmoke', borderBottomStyle:'solid'}}>
            <Col sm={2}>
                <p style={{fontWeight:'bold'}}>{item.name} <br/> 
                    <span style={{fontWeight:'normal'}}>
                        ({item.measurement === "area" ? "Area" : 
                          item.measurement === "width" ? "Width & Height" : 
                          item.measurement === "rft" ? "RFT" :  
                          item.measurement === "qty" ? "Quantity" : 
                          item.measurement === "length" ? "Length & Width" : 
                          item.measurement === "selection" ? "Type" : null})
                    </span>
                </p>
            </Col>
            
            {item.type === 'woodwork' ? (
                item.material.map((item2, index2) => (
                    <Col sm={1} key={index2}>
                        <p className='w-100'>{item2.label}</p>
                        <input type='number' value={Math.round(parseInt(item2.value) + (parseInt(item2.value) * 15 / 100))} placeholder='price' className='w-100' disabled/>
                        {item2.oldvalue && <input type='number' value={Math.round(parseInt(item2.oldvalue) + (parseInt(item2.oldvalue) * 15 / 100))} placeholder='price' className='w-100' disabled/>}
                    </Col>
                ))
            ) : (
                item.material.map((item2, index2) => (
                    <Col sm={1} key={index2}>
                        <p className='w-100'>{item2.label}</p>
                        <input type='number' value={item2.value} placeholder='price' className='w-100' disabled/>
                        {item2.oldvalue && <input type='number' value={item2.oldvalue} placeholder='price' className='w-100' disabled/>}
                    </Col>
                ))
            )}
        </Row>
    );

    return (
        <Container fluid>
            <Row>
                <Col className='px-5 pb-5'>
                    <img src={require('../assests/sitelogo.png')} alt='Dashboard' className='logoImg'/>
                </Col>
            </Row>
            
            {/* Search Bar */}
            <Row className="mb-4 px-3">
                <Col md={6} className="mx-auto">
                    <InputGroup>
                        <InputGroup.Text>
                            <Search />
                        </InputGroup.Text>
                        <Form.Control
                            type="text"
                            placeholder="Search items by name or material..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        {searchTerm && (
                            <InputGroup.Text 
                                style={{cursor: 'pointer'}}
                                onClick={() => setSearchTerm('')}
                            >
                                ✕
                            </InputGroup.Text>
                        )}
                    </InputGroup>
                </Col>
            </Row>

            {/* Search Results Section */}
            {searchTerm && (
                <Row className="mb-4">
                    <Col>
                        <Accordion defaultActiveKey="search-results">
                            <Accordion.Item eventKey="search-results">
                                <Accordion.Header>Search Results</Accordion.Header>
                                <Accordion.Body>
                                    {matchedCategories.length === 0 ? (
                                        <p className="text-center">No items found matching "{searchTerm}"</p>
                                    ) : (
                                        matchedCategories.map(category => (
                                            <div key={category.name}>
                                                <h5 className="mt-3 mb-3">{category.name}</h5>
                                                {filterItemsBySearch(category.data).map(item => renderItemRow(item))}
                                            </div>
                                        ))
                                    )}
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>
                </Row>
            )}

            {/* Regular Accordion Categories */}
            <Row>
                <Accordion>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>Kitchen</Accordion.Header>
                        <Accordion.Body>
                            {filterItemsBySearch(kitchenThingsData).map(item => renderItemRow(item))}
                        </Accordion.Body>
                    </Accordion.Item>
                    
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>Bedroom</Accordion.Header>
                        <Accordion.Body>
                            {filterItemsBySearch(bedroomThingsData).map(item => renderItemRow(item))}
                        </Accordion.Body>
                    </Accordion.Item>
                    
                    <Accordion.Item eventKey="2">
                        <Accordion.Header>Foyer</Accordion.Header>
                        <Accordion.Body>
                            {filterItemsBySearch(foyerThingsData).map(item => renderItemRow(item))}
                        </Accordion.Body>
                    </Accordion.Item>
                    
                    <Accordion.Item eventKey="3">
                        <Accordion.Header>Living Room</Accordion.Header>
                        <Accordion.Body>
                            {filterItemsBySearch(livingThingsData).map(item => renderItemRow(item))}
                        </Accordion.Body>
                    </Accordion.Item>
                    
                    <Accordion.Item eventKey="4">
                        <Accordion.Header>Other Works</Accordion.Header>
                        <Accordion.Body>
                            {filterItemsBySearch(otherWorkThingsData).map(item => renderItemRow(item))}
                        </Accordion.Body>
                    </Accordion.Item>
                    
                    <Accordion.Item eventKey="5">
                        <Accordion.Header>Loose Furniture</Accordion.Header>
                        <Accordion.Body>
                            {filterItemsBySearch(looseThingsData).map(item => renderItemRow(item))}
                        </Accordion.Body>
                    </Accordion.Item>
                    
                    <Accordion.Item eventKey="6">
                        <Accordion.Header>Accessories</Accordion.Header>
                        <Accordion.Body>
                            {filterItemsBySearch(accessoriesThingsData).map(item => renderItemRow(item))}
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </Row>
        </Container>
    )
}

export default PriceListKKT